/** The one tint every "Backfill" chip carries: the status badge on the detail
 * page, the Status cell in the queue and the Type chip in both. A BACKFILL run
 * is a locked mirror of something already billed, never a step in the
 * DRAFT → SENT workflow, so it gets a colour none of those states use.
 *
 * Filled rather than outlined like the workflow statuses: the palette's only
 * purple (`tags-purple`) is too light to read as text on white, so the pill
 * carries the purple and the text stays black. */
export const BACKFILL_CHIP_CLASS = "border border-tags-purple bg-accent-light-purple text-black";

/** Ops-facing wording for ``InvoicingRun.backfill_source``. The API sends it as
 * a plain string, blank on every run that is not a backfill, rather than an
 * enum, so a source added later reads raw instead of failing the typecheck. */
const BACKFILL_SOURCE_LABELS: Record<string, string> = {
  INVOICED: "Invoiced.com",
  DIRECT_CHARGE: "Direct charge",
};

export const backfillSourceLabel = (source: string): string => BACKFILL_SOURCE_LABELS[source] ?? source;
